import * as React from 'react';
import styled, { StyledFunction, StyledComponentClass } from 'styled-components';
import { theme } from '../../theme/defaultTheme';
import { breakpoints } from '../../theme/utils/util';
import { ColumnProps } from './Column';
import { GridContextProps } from '../grid/GridContext';
import { BreakpointConfigType } from '../../constants/types';

const column: StyledFunction<ColumnProps & GridContextProps> = styled.div;

/** @component */
export const StyledColumnDiv = column`
  padding-left: ${props => props.grid.columnGap / 2}px;
  padding-right: ${props => props.grid.columnGap / 2}px;
  
  ${props => {
    const { span, grid } = props;
    
    return spanStyles(theme, span, grid.columns);
  }}
  
  ${props => {
    const { offset, grid } = props;
  
    return offsetStyles(offset, grid.columns);
  }}
`;

StyledColumnDiv.defaultProps = {
  theme
};

function offsetStyles(offset: number, columns: number) {
  if (offset) {
    const width = getWidth(offset, columns);
    return `
        margin-left: ${width};
      `;
  }
}

// tslint:disable-next-line:no-shadowed-variable no-any
function spanStyles(theme: any, span: BreakpointConfigType | number, columns: number) {
  if (typeof span === 'number') {
    const width = getWidth(span, columns);
    return `
        width: ${width};
        flex-basis: ${width}
      `;
  } else {
    const points = breakpoints(theme, span, spanConfig(theme, span, columns));

    const keys = [...Object.keys(points)];

    return keys.map(key => {
      return points[key];
    }).join('');
  }
}

// tslint:disable-next-line:no-shadowed-variable no-any
function spanConfig(theme: any, spans: BreakpointConfigType, columns: number) {
  const styles: BreakpointConfigType = {};

  const keys = [...Object.keys(theme.breakpoint), 'default'];

  keys.forEach(key => {
    const value = spans[key];

    if (value) {

      const width = getWidth(value, columns);

      styles[key] = `width: ${width}; flex-basis: ${width};`;
    }
  });

  return styles;
}

function getWidth(span: number, columns: number) {
  return `${span / columns * 100}%`;
}
